'use client';
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "ListItem", {
    enumerable: true,
    get: function() {
        return ListItem;
    }
});
const _interop_require_wildcard = require("@swc/helpers/_/_interop_require_wildcard");
const _react = /*#__PURE__*/ _interop_require_wildcard._(require("react"));
const _reactsharedcontexts = require("@fluentui/react-shared-contexts");
const _useListItem = require("./useListItem");
const _renderListItem = require("./renderListItem");
const _useListItemStylesstyles = require("./useListItemStyles.styles");
const ListItem = /*#__PURE__*/ _react.forwardRef((props, ref)=>{
    const state = (0, _useListItem.useListItem_unstable)(props, ref);
    (0, _useListItemStylesstyles.useListItemStyles_unstable)(state);
    (0, _reactsharedcontexts.useCustomStyleHook_unstable)('useListItemStyles_unstable')(state);
    return (0, _renderListItem.renderListItem_unstable)(state);
});
ListItem.displayName = 'ListItem';
